<div *ngIf="deviceParamGatewayV3Cron">

    <form [formGroup]="cronForm" *ngIf="editable">
        <div class="edit-container-params">
            <h4>{{'LIRIS_DATA'|translate}}</h4>
            <mat-form-field>
                <input matInput placeholder="{{'EVERY'|translate}} :" formControlName="dataLirisValue" type="number"
                       (keyup)="setDeviceWithForm()">
            </mat-form-field>
            <mat-form-field>
                <mat-select placeholder="{{'INTERVAL'|translate}} :" formControlName="dataLirisUnit"
                            (selectionChange)="setDeviceWithForm()">
                    <mat-option value="s">s</mat-option>
                    <mat-option value="m">m</mat-option>
                    <mat-option value="h">h</mat-option>
                    <mat-option value="d">d</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-slide-toggle formControlName="dataLirisEnable" (change)="setDeviceWithForm()">
                {{cronForm.value.dataLirisEnable ? ('ACTIVE' | translate) :
                ('INACTIVE' | translate)}}
            </mat-slide-toggle>
        </div>
        <br/>
        <div class="edit-container-params mat-input-hidden">
            <h4>{{'LIRIS_SYNC_TIME'|translate}}</h4>
            <mat-form-field>
                <input matInput placeholder="{{'EVERY'|translate}} :" formControlName="syncLirisValue" type="number"
                       (keyup)="setDeviceWithForm()">
            </mat-form-field>
            <mat-form-field>
                <mat-select placeholder="{{'INTERVAL'|translate}} :" formControlName="syncLirisUnit"
                            (selectionChange)="setDeviceWithForm()">
                    <mat-option value="s">s</mat-option>
                    <mat-option value="m">m</mat-option>
                    <mat-option value="h">h</mat-option>
                    <mat-option value="d">d</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-slide-toggle formControlName="syncLirisEnable" (change)="setDeviceWithForm()">
                {{cronForm.value.syncLirisEnable ? ('ACTIVE' | translate) :
                ('INACTIVE' | translate)}}
            </mat-slide-toggle>
        </div>
        <br/>
        <div class="edit-container-params mat-input-hidden">
            <h4>{{'POST_LIRIS_FILES_FROM_GATEWAY'|translate}}</h4>
            <mat-form-field>
                <input matInput placeholder="{{'EVERY'|translate}} :" formControlName="postLirisFilesFromGatewayValue"
                       type="number"
                       (keyup)="setDeviceWithForm()">
            </mat-form-field>
            <mat-form-field>
                <mat-select placeholder="{{'INTERVAL'|translate}} :" formControlName="postLirisFilesFromGatewayUnit"
                            (selectionChange)="setDeviceWithForm()">
                    <mat-option value="s">s</mat-option>
                    <mat-option value="m">m</mat-option>
                    <mat-option value="h">h</mat-option>
                    <mat-option value="d">d</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-slide-toggle formControlName="postLirisFilesFromGatewayEnable" (change)="setDeviceWithForm()">
                {{cronForm.value.postLirisFilesFromGatewayEnable ? ('ACTIVE' | translate) :
                ('INACTIVE' | translate)}}
            </mat-slide-toggle>
        </div>
        <br/>
        <div class="edit-container-params">
            <h4>{{'GET_GATEWAY_CONFIG_BY_UID'|translate}}</h4>
            <mat-form-field>
                <input matInput placeholder="{{'EVERY'|translate}} :" formControlName="getGatewayConfigByUidValue"
                       type="number"
                       (keyup)="setDeviceWithForm()">
            </mat-form-field>
            <mat-form-field>
                <mat-select placeholder="{{'INTERVAL'|translate}} :" formControlName="getGatewayConfigByUidUnit"
                            (selectionChange)="setDeviceWithForm()">
                    <mat-option value="s">s</mat-option>
                    <mat-option value="m">m</mat-option>
                    <mat-option value="h">h</mat-option>
                    <mat-option value="d">d</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-slide-toggle formControlName="getGatewayConfigByUidEnable" (change)="setDeviceWithForm()">
                {{cronForm.value.getGatewayConfigByUidEnable ? ('ACTIVE' | translate) :
                ('INACTIVE' | translate)}}
            </mat-slide-toggle>
        </div>
    </form>

    <div *ngIf="!editable" class="read-container-params">
        <h4>{{'LIRIS_DATA'|translate}}</h4>
        <mat-form-field>
            <input matInput placeholder="{{'EVERY'|translate}} :"
                   [value]="deviceParamGatewayV3Cron.liris_data ? getValue(deviceParamGatewayV3Cron.liris_data.every) : null"
                   [readonly]="true">
        </mat-form-field>
        <mat-form-field>
            <mat-select placeholder="{{'INTERVAL'|translate}} :"
                        [value]="getUnit(deviceParamGatewayV3Cron.liris_data.every)"
                        [disabled]="true">
                <mat-option value="s">s</mat-option>
                <mat-option value="m">m</mat-option>
                <mat-option value="h">h</mat-option>
                <mat-option value="d">d</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-slide-toggle [ngModel]="getEnable(deviceParamGatewayV3Cron.liris_data.enable)" [disabled]="true">
            {{getEnable(deviceParamGatewayV3Cron.liris_data.enable) ? ('ACTIVE' | translate) :
            ('INACTIVE' | translate)}}
        </mat-slide-toggle>
    </div>

    <div *ngIf="!editable && deviceParamGatewayV3Cron.liris_sync_time !== undefined" class="read-container-params mat-input-hidden">
        <h4>{{'LIRIS_SYNC_TIME'|translate}}</h4>
        <mat-form-field>
            <input matInput placeholder="{{'EVERY'|translate}} :"
                   [value]="getValue(deviceParamGatewayV3Cron.liris_sync_time.every)"
                   [readonly]="true">
        </mat-form-field>
        <mat-form-field>
            <mat-select placeholder="{{'INTERVAL'|translate}} :"
                        [value]="getUnit(deviceParamGatewayV3Cron.liris_sync_time.every)"
                        [disabled]="true">
                <mat-option value="s">s</mat-option>
                <mat-option value="m">m</mat-option>
                <mat-option value="h">h</mat-option>
                <mat-option value="d">d</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-slide-toggle [ngModel]="getEnable(deviceParamGatewayV3Cron.liris_sync_time.enable)" [disabled]="true">
            {{getEnable(deviceParamGatewayV3Cron.liris_sync_time.enable) ? ('ACTIVE' | translate) :
            ('INACTIVE' | translate)}}
        </mat-slide-toggle>
    </div>

    <div *ngIf="!editable && deviceParamGatewayV3Cron.post_liris_files_from_gateway !== undefined"
         class="read-container-params mat-input-hidden">
        <h4>{{'POST_LIRIS_FILES_FROM_GATEWAY'|translate}}</h4>
        <mat-form-field>
            <input matInput placeholder="{{'EVERY'|translate}} :"
                   [value]="getValue(deviceParamGatewayV3Cron.post_liris_files_from_gateway.every)" [readonly]="true">
        </mat-form-field>
        <mat-form-field>
            <mat-select placeholder="{{'INTERVAL'|translate}} :"
                        [value]="getUnit(deviceParamGatewayV3Cron.post_liris_files_from_gateway.every)"
                        [disabled]="true">
                <mat-option value="s">s</mat-option>
                <mat-option value="m">m</mat-option>
                <mat-option value="h">h</mat-option>
                <mat-option value="d">d</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-slide-toggle [ngModel]="getEnable(deviceParamGatewayV3Cron.post_liris_files_from_gateway.enable)"
                          [disabled]="true">
            {{getEnable(deviceParamGatewayV3Cron.post_liris_files_from_gateway.enable) ? ('ACTIVE' | translate) :
            ('INACTIVE' | translate)}}
        </mat-slide-toggle>
    </div>

    <div *ngIf="!editable && deviceParamGatewayV3Cron.get_gateway_config_by_uid !== undefined"
         class="read-container-params">
        <h4>{{'GET_GATEWAY_CONFIG_BY_UID'|translate}}</h4>
        <mat-form-field>
            <input matInput placeholder="{{'EVERY'|translate}} :"
                   [value]="getValue(deviceParamGatewayV3Cron.get_gateway_config_by_uid.every)"
                   [readonly]="true">
        </mat-form-field>
        <mat-form-field>
            <mat-select placeholder="{{'INTERVAL'|translate}} :"
                        [value]="getUnit(deviceParamGatewayV3Cron.get_gateway_config_by_uid.every)"
                        [disabled]="true">
                <mat-option value="s">s</mat-option>
                <mat-option value="m">m</mat-option>
                <mat-option value="h">h</mat-option>
                <mat-option value="d">d</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-slide-toggle [ngModel]="getEnable(deviceParamGatewayV3Cron.get_gateway_config_by_uid.enable)"
                          [disabled]="true">
            {{getEnable(deviceParamGatewayV3Cron.get_gateway_config_by_uid.enable) ? ('ACTIVE' | translate) :
            ('INACTIVE' | translate)}}
        </mat-slide-toggle>
    </div>

</div>




